import { LocalDateTime } from 'js-joda';

import { LockOptions } from 'types';
import { consumer, core } from '@tock/coretypes';
import BaseComponent from '@tock/shared/components/BaseComponent';
import EventModalActions from 'components/business/events/EventModalActions';

interface Props {
  business: consumer.IBusinessConfig;
  event: consumer.IOffering;
  currentLock?: core.TicketGroup;
  onAttemptLock(dateTime: LocalDateTime, priceCents: number, options: LockOptions): Promise<void>;
  onSearch(size: number, date: string, time: string): void; // Updates the browser url query params
  waitlistUrl: string;
  selectedSize: number;
  ticketTypeId: number;
}

class EventPreCheckoutDetails extends BaseComponent<Props> {
  render() {
    const {
      business,
      event,
      currentLock,
      onAttemptLock,
      onSearch,
      waitlistUrl,
      selectedSize,
      ticketTypeId,
    } = this.props;

    return (
      <div className="Animation--routeTransitionAppear">
        <EventModalActions
          currentLock={currentLock}
          event={event}
          onAttemptLock={onAttemptLock}
          waitlistUrl={waitlistUrl}
          onSearch={onSearch}
          selectedSize={selectedSize}
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          showWaitlist={business.showWaitlist!}
          ticketTypeId={ticketTypeId}
        />
      </div>
    );
  }
}
export default EventPreCheckoutDetails;
